import React from "react";
import './Home';
import './Servicios.css';
import Comer from '../assets/images/Infraestructura-TI.jpg';
import ERP from '../assets/images/ERP.png';
import Servi from '../assets/images/Servi.jpg';
import ServiciosIMG from '../assets/images/Servicios.png';
import Facebok from '../assets/images/Facebok.png';
import Wasa from '../assets/images/Wasa.png';
import insta from '../assets/images/insta.png';
import videoDecorativo2 from '../assets/images/Video4.mp4';
import Ubi from '../assets/images/Ubi.png';
import Telefono from '../assets/images/Telefono.png';
import Email34 from '../assets/images/Correo.png';
import RedesFondo from '../assets/images/Red-Neuronal.png';
import checkAnim from '../assets/images/check.gif';

import { useEffect, useRef, useState } from 'react';

function Servicios() {
  const serviciosRef = useRef(null);

  const scrollToServicios = () => {
  const offset = 200; // Ajusta este valor según tu header
  const element = serviciosRef.current;
  if (element) {
    const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }
};
const [enviado, setEnviado] = useState(false);
  
    const handleSubmit = (e) => {
      e.preventDefault();
      const form = e.target;
  
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
      }).then(() => {
        setEnviado(true);
        form.reset();
        // Opcional: volver a mostrar formulario después de 5s
        // setTimeout(() => setEnviado(false), 5000);
      });
    };


  return (
   
      <div className="servicios-container">
        {/*Inicio Servicios*/}
        <div className="coming-soon-container2">
          <div className="coming-soon-text2">
            {/*Titulo Servicios Sección Inicio */}
            <h1>
              Nuestros Servicios <br />
            </h1>
            {/*Descripción Servicios Sección Inicio */}
            <h2>
              EN GRUPO IATEKZA OFRECEMOS INNOVACIONES TECNOLÓGICAS <br />
              PERSONALIZADAS PARA IMPULSAR LA EFICIENCIA Y EL CRECIMIENTO <br />
              DE TU EMPRESA , SOMOS ESPECIALISTAS EN LA ASESORIA<br />
              DE IMPLEMENTACION DE SISTEMAS ERP E INFRAESTRUCTURA DE TI.<br />
            </h2>
        
          </div>
{/* Video de fondo en la sección de inicio Servicios*/}
          <div className="coming-soon-image2">
            <video autoPlay muted loop playsInline>
              <source src={videoDecorativo2} type="video/mp4" />
              Tu navegador no soporta la etiqueta de video.
            </video>
          </div>
      
  
      
                      </div>
                    
                    {/*Bloque Menú Servicios*/}


  <div className="contenedor-servicios" ref={serviciosRef}>
    {/*Columna 1 infraestructura TI*/}
  <div className="tarjeta-servicio">
    {/*Imagen Columna 1 infraestructura TI*/}
    <img src={Comer} alt="Infraestructura TI" />
    {/* Titulo Columna 1 infraestructura TI*/}
    <h3>Infraestructura TI</h3>
    {/* Descripcion Columna 1 infraestructura TI*/}
    <p>Venta y distribución de equipos tecnológicos.</p>
    {/* Botón saber mas Columna 1 infraestructura TI*/}
    <a href="/Comercializacion" className="boton-servicio">Saber más</a>
  </div>

  <div className="linea-divisoria"></div>
{/*Columna 2 Asesoría Empresarial */}
  <div className="tarjeta-servicio">
    {/*Imagen Columna 2 Asesoría Empresarial*/} 
    <img src={ERP} alt="Consultoría de ERP" />
    {/* Titulo Columna 2 Asesoría Empresarial */}
    <h3>Asesoría Empresarial</h3>
    {/* Descripción Columna 2 Asesoría Empresarial  */}
    <p>Asesoria en procesos empresariales e implementación de sistemas ERP.</p>
    {/* Botón saber mas Columna 2 Asesoría Empresarial */}
    <a href="/Consultoria" className="boton-servicio">Saber más</a>
  </div>

  <div className="linea-divisoria"></div>

{/* Columna 3 Soluciones Tecnológicas */}
  <div className="tarjeta-servicio">
    {/*Imagen Columna 3 Soluciones Tecnológicas */}
    <img src={Servi} alt="Sistemas" />
    {/* Titulo Columna 3 Soluciones Tecnológicas */}
    <h3>Soluciones Tecnológicas</h3>
    {/* Descripción Columna 3 Sistemas */}
    <p>Innovación tecnológica personalizada para tu empresa.</p>
    {/* Botón saber más Columna 3 Sistemas */}
    <a href="/Sistemas" className="boton-servicio">Saber más</a>
  </div>
</div>


{/* Contenedor principal del formulario de contacto*/}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/*Titulo Formulario*/}
  <h2>
  {!enviado ? (
    'Contáctanos para más información'
  ) : (
    <>
    {/* Titulo al enviar*/}
      ¡¡¡ GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple20"
    >
      <input type="hidden" name="_captcha" value="false" />
{/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}

      {/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
      {/* Campo Número Telefónico */}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      {/* Campo Mensaje*/}
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>
      {/* Botón de envío del formulario*/}
      <button type="submit">Enviar</button>
    </form>
  ) : (
    <div className="confirmacion-envio20">
      {/* gift al enviar formulario */}
      <img src={checkAnim} alt="Éxito" />
      {/* Texto abajo al enviar*/}
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>



{/* Contenedor principal de pie de página con contacto*/}
<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-item">
    {/* Ubicación contacto*/}
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    {/* Numero contacto*/}
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    {/* Correo contacto*/}
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
    <ul>
      {/* IAutomatiza CFDI Colum 3*/}
        <li><a href="/">• IAutomatiza CFDI</a></li>
        {/*Facturacion Electronica Colum 3*/}
        <li><a href="/Facturacion">• Facturación Electronica</a></li>
        
      </ul>
      {/*Facebook Colum 2*/}
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Instagram Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
         {/*Sobre Nosotros Colum 3*/}
        <li><a href="/Nosotros">Sobre nosotros</a></li>
         {/*Casos de Exito Colum 3*/}
        <li><a href="/CasosExito">Casos de Éxito</a></li>
        {/*Aviso Legal Colum 3*/}
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

{/*Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>




    </div>
  );
}

export default Servicios;



